import { render, staticRenderFns } from "./dailog-call-detail.vue?vue&type=template&id=c4cc5eea&scoped=true"
import script from "./dailog-call-detail.vue?vue&type=script&lang=js"
export * from "./dailog-call-detail.vue?vue&type=script&lang=js"
import style0 from "./dailog-call-detail.vue?vue&type=style&index=0&id=c4cc5eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cc5eea",
  null
  
)

export default component.exports